import React from "react";
import Flex from "../../Flex";
import { Typography } from "../../Typography";
import { showOutsideLabel } from "./helpers";
import { ProgressCircleProps } from "./types";

type ConditionalOutsideSublabelProps = Pick<ProgressCircleProps, "sublabel" | "sublabelColor"> & {
    size: NonNullable<ProgressCircleProps["size"]>;
    children: React.ReactChild;
};

/**
 * @internal
 */
const ConditionalOutsideSublabel: React.FC<ConditionalOutsideSublabelProps> = ({
    sublabel,
    sublabelColor,
    size,
    children
}) => {
    if (sublabel !== undefined && showOutsideLabel(size)) {
        return (
            <Flex column spacing={0.5} alignItems="center" maxWidth="fit-content">
                {children}
                <Typography
                    as="span"
                    variant="label-x-small-medium"
                    color={sublabelColor}
                    styles={{ transition: "color 150ms ease-in-out", textAlign: "center" }}
                >
                    {sublabel}
                </Typography>
            </Flex>
        );
    }

    return children as ReturnType<React.FC>;
};

ConditionalOutsideSublabel.displayName = "ConditionalOutsideSublabel";

export default ConditionalOutsideSublabel;
